@if (linkable) {
  <a
    [routerLink]="{ cxRoute: userCellRoute, params: routeModel } | cxUrl"
    [tabindex]="tabIndex"
    >
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </a>
} @else {
  @if (label) {
    <span
      class="text"
      title="{{ label | cxTranslate }}"
      [class.is-active]="isActive"
      >
      {{ label | cxTranslate }}</span
      >
    }
  }

  <ng-template #text>
    @if (label) {
      <span
        class="text"
        title="{{ label | cxTranslate }}"
        [class.is-active]="isActive"
        >
        {{ label | cxTranslate }}</span
        >
      }
    </ng-template>
